import { useEffect, useState } from 'react'
import { onlineManager } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'

export function useOfflineToast() {
  const [isOffline, setIsOffline] = useState(false)
  const intl = useIntl()
  useEffect(() => {
    const unsubscribe = onlineManager.subscribe((isOnline) => {
      setIsOffline(!isOnline)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (isOffline) {
      toast.error(intl.formatMessage({ id: 'common.network.offline' }), {
        toastId: 'offline',
        autoClose: false,
        closeButton: false
      })
    } else {
      toast.dismiss('offline')
    }
  }, [isOffline])
}
